<template>
  <template v-if="filter.key == 'places'">
    <Autocomplete
      :placeholder="messages.map_filters_places_placeholder"
      right-icon
      :show-powered-by="false"
      :use-autocomplete="usePlacesAutocomplete"
      :clear-query-on-focus="clearQueryOnFocus"
      @onSearchPlace="onSearchPlace"
    />
  </template>

  <template v-else-if="filter.key == 'keywords' && filter?.modal?.enabled">
    <PointSearchModal
      ref="pointSearchModal"
      :filter="filter"
      
    />
  </template>
  <template v-else-if="filter.key == 'keywords'">
    <KeywordSearcher
      :placeholder="messages.map_filters_keywords_placeholder"
      @onEnterKeywordInput="handleKeywordInput"
      instant-mode
      right-icon
      sync-with-store
    />
  </template>
</template>

<script setup>
/**
 * FilterComponent.vue
 * HeaderFiltersで使用するコンポーネントをまとめたコンポーネント
 * 各フォームコンポーネントの戻り値をここで受け取り処理する
 * 
 * ただし、PointSearchModalだけは動作が他と異なり、処理も多いので PointSearchModal コンポーネント内で処理を完結している
 */
 import uikit from 'uikit'

import { computed, defineProps, ref } from 'vue'
import { useStore } from 'vuex'

import Autocomplete from '@/components/common/AutocompleteV2.vue'
import KeywordSearcher from '@/components/common/KeywordSearcher.vue'
import PointSearchModal from '@/components/map/Panel/PointSearchModal.vue'

import MapService from '@/services/MapService.ts'


const messages = computed(() => storelocator.messages)

// ref参照用
const pointSearchModal = ref(null);

const props = defineProps({
  filter: Object
})

const store = useStore()

const usePlacesAutocomplete = computed(() => {
  return storelocator.map.searchers?.places?.autocomplete?.enabled !== false
})

/**
 * true: フォーカス時に入力を消す（デフォルト）
 * false: 入力を残しクリアボタンで消す
 * design の map.filters.places を優先し、未設定時は extra_config.searchers にフォールバック
 */
const clearQueryOnFocus = computed(() => {
  const fromDesign = storelocator.map.filters?.places?.clear_query_on_focus
  if (fromDesign !== undefined) {
    return fromDesign !== false
  }
  return storelocator.map.searchers?.places?.clear_query_on_focus !== false
})

/**
  * キーワード検索実行
  * KeywordSearcherコンポーネントからクエリを受け取りリストに反映し
  * analyticsにSearchByKeywordイベントを送信する
  * 
  * @param query (String) 検索ワード. 空 or null で全件表示 ( =リセット)
  */
function handleKeywordInput(query) {
  // 削除済みフィールドを除外した検索対象を取得
  const allTargets = storelocator.map.filters?.keywords?.targets || ['name', 'address']
  const fields = storelocator.fields || {}
  
  const filteredTargets = allTargets.filter(target => {
    // 検索対象チェック
    // 削除済みを除外
    const fieldExists = target in fields
    // 有効チェックOFF状態を除外
    const isDeleted = fieldExists && fields[target].deleted === true
    
    return fieldExists && !isDeleted
  })
  const payload = {
    text: query,
    targets: filteredTargets
  }

  store.dispatch("changeFilterText", payload)

  storelocator.analytics.client?.send(
    'SearchByKeyword',
    {
      Keyword: query,
    }
  )
}

/**
 * Autocomplete#onSearchPlace
 * @param place (Object) { query, location, name, viewport, by, status }
 */
function onSearchPlace(place) {
  // 失敗時のメッセージ出し
  if (place.status === 'ZERO_RESULTS') {
    uikit.notification({
      message: messages.value.map_search_place_zero_result,
      pos: 'top-center',
      timeout: 3000
    })
  } else if (place.status === 'ERROR') {
    uikit.notification({
      message: messages.value.common_failed_network_connect,
      pos: 'top-center',
      timeout: 3000
    })
  }

  // 位置を取得できなかった場合（Geocodingの場合、地域の付与を諦める）
  if (!place.location) {
    if (storelocator.analytics.client) {
      storelocator.analytics.client.context.PlaceQuery = place.query
      storelocator.analytics.client.send('SearchPlace', {
        SearchPlaceBy: place.by,
      })
    }

    return
  }

  if (place.bounds) {
    MapService.fitBounds(place.bounds, 17)
  } else {
    MapService.map.setZoom(17)
    MapService.map.panTo(place.location)
  }

  store.dispatch('closePanel')

  // 位置を取得できた場合は地域も付与
  if (storelocator.analytics.client) {
    storelocator.analytics.client.context.PlaceQuery = place.query

    const params = {
      SearchPlaceBy: place.by,
    }

    if (place.by === 'Geocoding') {
      params.pref = place.pref
      params.city = place.city
    }

    storelocator.analytics.client.send('SearchPlace', params)
  }
}

</script>